import { viewActions } from '../actions/view.actions';
import { CONFIG } from '../helper/config';
const initialState = {
    active_loader: false,
    loading_time: CONFIG.LOADING_TIME,
    theme: 'light',
    is_license_expire: false,
    is_unregisterd_user: false,
    unregisterd_user_msg: '',
    sessionId:''
};

/**
 * viewState reducer
 * @function viewState
 * @param {Object} state - previous state
 * @param {Object} action - action payload
 * @returns {Object} new state
 * @property {boolean} active_loader - flag to toggle loader
 * @property {number} loading_time - time to show loader
 * @property {string} theme - theme of application
 * @property {boolean} is_license_expire - flag to indicate if license has expired
 * @property {boolean} is_unregisterd_user - flag to indicate if user is unregistered
 * @property {string} unregisterd_user_msg - message to show when user is unregistered
 * @property {string} sessionId - session ID
 */

export const viewState = (state = initialState, action: any) => {
    switch (action.type) {
        case viewActions.ACTIVE_LOADER:
            return {...state, ...{ active_loader: action.payload.active_loader, loading_time: action.payload.loading_time }};

        case viewActions.SET_THEME:
            return {...state, ...{ theme: action.payload.theme }};

        case viewActions.LICENSE_EXPIRE:
            return {...state, ...{ is_license_expire: action.payload.is_license_expire }};

        case viewActions.STORE_SESSION_ID:
            return { ...state, sessionId: action.payload.sessionId };

        case viewActions.UNREGISTERED_USER:
            return {...state, ...{
                is_unregisterd_user: action.payload.is_demo,
                unregisterd_user_msg: action.payload.msg
            }};
            
        default:
            return state;
    }
};
